import { gql } from '../types/generated/gql';

export const MEDIA_POLICY_FRAGMENT = gql(`
  fragment MediaPolicyFields on MediaPolicy {
    id
    mediaType
    gamePk
    feedType
    feedSubType
    language
    contentDate
  }
`);

export const VIEWING_POLICY_FRAGMENT = gql(`
  fragment ViewingPolicyFields on ViewingPolicy {
    id
    href
    action
    actionLabel
    name
    audienceHref
  }
`);

export const ESNI_RULE_FRAGMENT = gql(`
  fragment EsniRuleFields on EsniRule {
    id
    name
    type
    priority
    query
    status
    actions {
      actionType
      metadata
    }
  }
`);

export const ESNI_MEDIA_PROCESSING_RESULT_FIELDS = gql(`
  fragment EsniMediaProcessingResultFields on EsniMediaProcessingResult {
    rules {
      id
      name
      type
      status
      priority
    }
    policies
  }
`);
